import { useEffect } from "react";
import { SITE_URL } from "@/data/company";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const Seo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, noindex]);
  return null;
};

export const HOME_SEO = {
  title: "Kota Stone Manufacturer & Supplier in India | Garg Stone Company, Kota — Since 1988",
  description: "Factory-direct Kota stone from Garg Stone Company, Kota (since 1988). Kota Blue, Kota Yellow, mirror polish, leather & shot-blast flooring, cobbles and cladding — delivered across India. WhatsApp for price.",
  path: "/",
};
